import { OrganisationType } from '@assetaccountant/core/models/enum/organisation-type';
import { OnboardingOrganisationRequirements } from '@assetaccountant/core/models/onboarding/onboarding-organisation-requirements';
import { OnboardingQuestion } from '@assetaccountant/core/models/onboarding/onboarding-question';

export const getOnboardingQuestions = () => [
  {
    name: 'organisationType',
    question: 'Are you a business or an accounting firm',
    optional: false,
    options: [
      { name: 'Business', value: OrganisationType.Business },
      { name: 'Accounting Firm', value: OrganisationType.AccountingFirm },
    ],
  } as OnboardingQuestion,
  {
    name: 'organisationRequirements',
    question: 'What do you need to do',
    optional: true,
    options: [
      { name: 'Depreciate Assets', value: OnboardingOrganisationRequirements.Depreciation },
    ],
  } as OnboardingQuestion,
];
